import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import { Form } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import FeeSystemMenu from "./FeeSystemMenu";
import ShowStudent from "../Shared/ShowStudent";
import moment from "moment";

function ReceiveAdvance() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [Code, setCode] = useState("");
  const [ValidCode, setValidCode] = useState(false);
  const [student, setStudent] = useState({});
  const [StudentID, setStudentID] = useState(0);

  const [searchLoading, setSearchLoading] = useState(false);
  const [searchValidated, setSearchValidated] = useState(false);

  const [Amount, setAmount] = useState("");
  const [ReceivedDate, setReceivedDate] = useState(new Date().toISOString().split("T")[0]);
  const [Description, setDescription] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitValidated, setSubmitValidated] = useState(false);

  const [receipt, setReceipt] = useState(null);

  const [pendingLedger, setPendingLedger] = useState([]);
  const [ledgerLoading, setLedgerLoading] = useState(false);

  useEffect(() => {
    document.title = "Receive Advance Payment";
  }, []);

  const fetchPendingLedger = (studentId) => {
    setLedgerLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: studentId,
    };

    axios({
      method: "post",
      url: config.base_url + "Student/GetStudentByID",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code == 1 && response.data.Student) {
          const ledger = response.data.Student.ADFeeLedger || [];
          const unpaid = ledger.filter(
            (item) => item.PendingFee > 0 && item.Is_Active === true
          );
          setPendingLedger(unpaid);
        } else {
          setPendingLedger([]);
        }
        setLedgerLoading(false);
      })
      .catch(function () {
        setPendingLedger([]);
        setLedgerLoading(false);
      });
  };

  const handleSearch = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setSearchValidated(true);
      setValidCode(false);
      return;
    }
    setSearchValidated(true);
    setSearchLoading(true);
    setReceipt(null);
    setPendingLedger([]);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Registration_No: Code,
    };

    axios({
      method: "post",
      url: config.base_url + "Student/GetStudentByRegistrationNo",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setStudent(response.data.Student);
          setStudentID(response.data.Student.Student_ID);
          setValidCode(true);
          fetchPendingLedger(response.data.Student.Student_ID);
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setValidCode(false);
        }
        setSearchLoading(false);
      })
      .catch(function () {
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setSearchLoading(false);
        setValidCode(false);
      });
  };

  const handleSubmitAdvance = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setSubmitValidated(true);
      return;
    }
    setSubmitValidated(true);
    setSubmitLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Student_ID: StudentID,
      Amount: parseFloat(Amount),
      StartDate: ReceivedDate,
      Description: Description || "Advance Fee",
    };

    axios({
      method: "post",
      url: config.base_url + "ADLedger/ReceiveAdvancePayment",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setReceipt(response.data.Receipt);
          setAmount("");
          setDescription("");
          setSubmitValidated(false);
          fetchPendingLedger(StudentID);
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setSubmitLoading(false);
      })
      .catch(function () {
        toast.error("Something went wrong.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setSubmitLoading(false);
      });
  };

  const totalPending = pendingLedger.reduce(
    (sum, item) => sum + item.PendingFee,
    0
  );

  return (
    <>
      <FeeSystemMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">
                        Fee System
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Receive Advance
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Receive Advance Payment</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="card">
                  <div className="card-body card-form-wrap">
                    {/* Step 1: Search Student */}
                    <div className="form-wrap">
                      <div className="form-legend">
                        Step 1. Search Student
                      </div>
                      <Form
                        noValidate
                        validated={searchValidated}
                        onSubmit={handleSearch}
                      >
                        <div className="row align-items-end">
                          <label className="col-md-3 col-form-label col-form-label-sm">
                            Student ID / Reg No / Name:
                          </label>
                          <div className="col-md-5">
                            <input
                              type="text"
                              className="form-control"
                              value={Code}
                              onChange={(e) => {
                                setCode(e.target.value);
                                setValidCode(false);
                                setReceipt(null);
                                setPendingLedger([]);
                              }}
                              placeholder="Enter Student ID, Registration No or Name"
                              required
                            />
                          </div>
                          <div className="col-md-2">
                            <button
                              type="submit"
                              className="button button-primary w-100"
                              disabled={searchLoading}
                            >
                              {searchLoading ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                "Search"
                              )}
                            </button>
                          </div>
                        </div>
                      </Form>
                    </div>

                    {/* Step 2: Show Student Info + Pending Challans */}
                    {Code.length !== 0 && ValidCode === true && (
                      <>
                        <div className="form-wrap">
                          <div className="form-legend">
                            Step 2. Student Details
                          </div>
                          <ShowStudent StudentID={StudentID} />

                          {/* Pending Challans Info */}
                          {ledgerLoading ? (
                            <div className="text-center mt-3">
                              <Spinner animation="border" size="sm" />
                            </div>
                          ) : pendingLedger.length > 0 ? (
                            <div className="mt-3">
                              <div
                                className="alert alert-warning"
                                role="alert"
                              >
                                <strong>
                                  <i className="ri-error-warning-line me-1"></i>
                                  Unpaid Challans Found:
                                </strong>{" "}
                                This student has {pendingLedger.length} unpaid
                                fee line(s) totalling{" "}
                                <strong>Rs. {totalPending}</strong>. After
                                receiving advance, you can adjust it against
                                these pending fees from the monthly adjustment
                                process.
                              </div>
                              <table className="table table-sm table-bordered">
                                <thead>
                                  <tr>
                                    <th>Fee Code</th>
                                    <th>Description</th>
                                    <th>Posting Date</th>
                                    <th className="text-end">Receivable</th>
                                    <th className="text-end">Received</th>
                                    <th className="text-end">Pending</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {pendingLedger.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item.FeeCode}</td>
                                      <td>{item.Description}</td>
                                      <td>
                                        {moment(item.PostingDate).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td className="text-end">
                                        {item.ReceiveableFee}
                                      </td>
                                      <td className="text-end">
                                        {item.ReceivedAmount}
                                      </td>
                                      <td className="text-end">
                                        <strong>{item.PendingFee}</strong>
                                      </td>
                                    </tr>
                                  ))}
                                  <tr>
                                    <td
                                      colSpan="5"
                                      className="text-end fw-bold"
                                    >
                                      Total Pending:
                                    </td>
                                    <td className="text-end fw-bold">
                                      Rs. {totalPending}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="mt-3">
                              <div className="alert alert-success" role="alert">
                                <i className="ri-checkbox-circle-line me-1"></i>
                                No unpaid challans found for this student.
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Step 3: Receive Advance */}
                        <div className="form-wrap">
                          <div className="form-legend">
                            Step 3. Receive Advance Amount
                          </div>
                          <Form
                            noValidate
                            validated={submitValidated}
                            onSubmit={handleSubmitAdvance}
                          >
                            <div className="row mb-3">
                              <label className="col-md-3 col-form-label col-form-label-sm">
                                Amount (Rs.):
                              </label>
                              <div className="col-md-3">
                                <input
                                  type="number"
                                  className="form-control"
                                  value={Amount}
                                  onChange={(e) => setAmount(e.target.value)}
                                  required
                                  min="1"
                                />
                                <div className="invalid-feedback">
                                  Please enter a valid amount.
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label className="col-md-3 col-form-label col-form-label-sm">
                                Received Date:
                              </label>
                              <div className="col-md-3">
                                <input
                                  type="date"
                                  className="form-control"
                                  value={ReceivedDate}
                                  onChange={(e) => setReceivedDate(e.target.value)}
                                  required
                                />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label className="col-md-3 col-form-label col-form-label-sm">
                                Description:
                              </label>
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={Description}
                                  onChange={(e) =>
                                    setDescription(e.target.value)
                                  }
                                  placeholder="Advance Fee"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-3 offset-md-9">
                                <button
                                  type="submit"
                                  className="button button-primary w-100"
                                  disabled={submitLoading}
                                >
                                  {submitLoading ? (
                                    <Spinner animation="border" size="sm" />
                                  ) : (
                                    "Receive Advance"
                                  )}
                                </button>
                              </div>
                            </div>
                          </Form>
                        </div>

                        {/* Receipt Slip - Print Format */}
                        {receipt && (
                          <>
                            <div className="form-wrap">
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="form-legend mb-0">
                                  Advance Receipt Slip
                                </div>
                                <button
                                  className="button button-primary button-icon"
                                  onClick={() => {
                                    const printContent = document.getElementById("advance-receipt-print").innerHTML;
                                    const win = window.open("", "_blank");
                                    win.document.write(`<html><head><title>Advance Receipt</title><style>body{margin:0;padding:0;font-family:Arial,sans-serif;font-size:11px;color:#000;}@media print{body{margin:0;padding:0;}}</style></head><body>${printContent}</body></html>`);
                                    win.document.close();
                                    win.focus();
                                    win.print();
                                    win.close();
                                  }}
                                >
                                  Print <i className="ri-printer-line"></i>
                                </button>
                              </div>
                            </div>

                            <div id="advance-receipt-print">
                              <div
                                style={{
                                  backgroundColor: "#FFF",
                                  color: "#000",
                                  width: "100%",
                                  fontSize: "11px",
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  style={{
                                    width: "700px",
                                    lineHeight: "18px",
                                    marginTop: "10px",
                                    pageBreakAfter: "always",
                                  }}
                                >
                                  <table style={{ width: "100%" }} cellSpacing={0} cellPadding={0}>
                                    <tbody>
                                      <tr>
                                        {/* College Copy */}
                                        <td style={{ width: "320px", paddingRight: "20px" }} valign="top" align="left">
                                          <AdvanceReceiptCopy receipt={receipt} copy="College Copy" />
                                          <div style={{ padding: "20px 0px 0px 0px" }}>
                                            <table style={{ width: "100%" }} cellSpacing={0} cellPadding={0}>
                                              <tbody>
                                                <tr>
                                                  <td style={{ height: "40px" }} valign="top" align="left">Officer</td>
                                                  <td valign="top" align="right">Cashier</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                          <div style={{ padding: "30px 0px 0px 0px" }} className="text-center">
                                            <p style={{ fontSize: "9px", color: "#999" }}>Powered By: www.softsolutions.com</p>
                                          </div>
                                        </td>

                                        {/* Dashed Separator */}
                                        <td style={{ width: "2px" }}>
                                          <div style={{ height: "500px", borderLeft: "2px dashed black" }}></div>
                                        </td>

                                        {/* Student Copy */}
                                        <td style={{ width: "320px", paddingLeft: "20px" }} valign="top" align="left">
                                          <AdvanceReceiptCopy receipt={receipt} copy="Student Copy" />
                                          <div style={{ padding: "20px 0px 0px 0px" }}>
                                            <table style={{ width: "100%" }} cellSpacing={0} cellPadding={0}>
                                              <tbody>
                                                <tr>
                                                  <td style={{ height: "40px" }} valign="top" align="left">Officer</td>
                                                  <td valign="top" align="right">Cashier</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                          <div style={{ padding: "30px 0px 0px 0px" }} className="text-center">
                                            <p style={{ fontSize: "9px", color: "#999" }}>Powered By: www.softsolutions.com</p>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function AdvanceReceiptCopy({ receipt, copy }) {
  return (
    <>
      <div style={{ padding: "12px 0px 8px 0px", minHeight: "60px" }}>
        <table style={{ width: "100%" }} cellSpacing={0} cellPadding={0}>
          <tbody>
            <tr>
              <td valign="top" align="center">
                <img
                  src={`${config.images}L001.jpg`}
                  width="268"
                  height="52"
                  alt=""
                />
              </td>
            </tr>
            <tr>
              <td
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "6px 0px",
                }}
                align="center"
              >
                Advance Fee Receipt
              </td>
            </tr>
            <tr>
              <td
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  padding: "4px 0px 8px 0px",
                }}
                align="center"
              >
                {copy}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ padding: "0px 0px 7px 0px" }}>
        <table
          style={{ width: "100%", borderCollapse: "collapse" }}
          cellSpacing={2}
          cellPadding={2}
        >
          <tbody>
            <tr>
              <td style={{ border: "1px solid #000", width: "100px" }}>
                Receipt No:
              </td>
              <td style={{ border: "1px solid #000", fontWeight: "bold" }}>
                {receipt.AdvancePaymentID}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", width: "100px" }}>
                Student Code:
              </td>
              <td style={{ border: "1px solid #000", fontWeight: "bold" }}>
                {receipt.Registration_No || receipt.Student_ID}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", width: "100px" }}>
                Student Name:
              </td>
              <td style={{ border: "1px solid #000" }}>
                {receipt.Student_Name}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", width: "100px" }}>
                Father Name:
              </td>
              <td style={{ border: "1px solid #000" }}>
                {receipt.Father_Name}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ padding: "7px 0px 0px 0px" }}>
        <table
          style={{ width: "100%", borderCollapse: "collapse" }}
          cellSpacing={2}
          cellPadding={2}
        >
          <tbody>
            <tr>
              <td style={{ border: "1px solid #000", width: "100px" }}>
                Description
              </td>
              <td
                style={{ border: "1px solid #000", width: "80px" }}
                align="right"
              >
                Amount
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000" }}>
                {receipt.Description || "Advance Fee"}
              </td>
              <td style={{ border: "1px solid #000" }} align="right">
                {receipt.Amount}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", fontWeight: "bold" }}>
                Total
              </td>
              <td
                style={{ border: "1px solid #000", fontWeight: "bold" }}
                align="right"
              >
                Rs. {receipt.Amount}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ padding: "5px 0px" }}>
        <table
          style={{ width: "100%", borderCollapse: "collapse" }}
          cellSpacing={2}
          cellPadding={2}
        >
          <tbody>
            <tr>
              <td style={{ border: "1px solid #000", width: "100px" }}>
                Received Date:
              </td>
              <td style={{ border: "1px solid #000" }}>
                {moment(receipt.ReceivedDate).format("DD/MM/YYYY hh:mm A")}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", width: "100px" }}>
                Received By:
              </td>
              <td style={{ border: "1px solid #000" }}>
                {receipt.ReceivedBy_Name}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ReceiveAdvance;
